<template>
  <section class="mt-5">
    <h2>クーリング・オフお申し出フォーム</h2>
    <div class="form-navi my-5">
      <ul class="d-flex">
        <li>入力</li>
        <li class="here">内容確認</li>
        <li>送信完了</li>
      </ul>
    </div>
    <div class="form-content">
      <p>以下の内容でよろしければ送信するを押してください。</p>
      <div class="form-member my-5">
        <div class="inner">
          <form id="frmConfirm">
            <dl>
              <dt>申出日</dt>
              <dd>{{ date }}</dd>
              <dt>サービス名</dt>
              <dd>{{ selected }}</dd>
              <dt>会員番号</dt>
              <dd>{{ no }}</dd>
              <dt>ご契約者名</dt>
              <dd>{{ name }}</dd>
              <dt>ご契約者名（フリガナ）</dt>
              <dd>{{ nameKana }}</dd>
              <dt>郵便番号</dt>
              <dd>{{ zipCode }}</dd>
              <dt>住所</dt>
              <dd>{{ address }}</dd>
              <dt>電話番号</dt>
              <dd>{{ tel }}</dd>
              <dt>メールアドレス</dt>
              <dd>{{ txtMail }}</dd>
              <dt>その他ご要望</dt>
              <dd>{{ ex }}</dd>
            </dl>
          </form>
          <div class="box-p-20 text-center mt-5">
            <button
              v-on:click="putData"
              id="btnSend"
              type="button"
              class="confirm-01 clear"
            >
              送信する
            </button>
          </div>
          <div class="box-p-20 text-center">
            <router-link
              :to="{ path: '/cancel', query: { ref: 'Confirm' } }"
              class="back-01 btn d-inline-block"
              >入力画面に戻る</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
import Store from "../../modules/Store";
let store = new Store();
export default {
  data() {
    return {
      selected: "",
      date: "",
      no: "",
      name: "",
      nameKana: "",
      zipCode: "",
      address: "",
      tel: "",
      txtMail: "",
      ex: "",
    };
  },
  mounted() {
    if (store.get("cancel") == "") {
      this.$router.push("/cancel");
    } else {
      this.getData();
    }
    window.scroll(0, 0);
  },
  methods: {
    getData() {
      let items = JSON.parse(store.get("cancel"));
      this.selected = items["selected"];
      this.date = items["date"];
      this.no = items["no"];
      this.name = items["name"];
      this.nameKana = items["nameKana"];
      this.zipCode = items["zipCode"];
      this.address = items["address"];
      this.tel = items["tel"];
      this.txtMail = items["txtMail"];
      this.ex = items["ex"];
    },
    putData() {
      console.log("putdate");
      let params = [
        this.selected,
        this.date,
        this.no,
        this.name,
        this.nameKana,
        this.zipCode,
        this.address,
        this.tel,
        this.txtMail,
        this.ex,
      ];
      console.log("params");
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "setCancel",
        params,
        true
      );
      console.log("request");
      request
        .create()
        .post("", requestParams)
        .then(() => {
          store.remove("cancel");
          this.$router.push("/cancel/end");
        });
      console.log("requestend");
    },
  },
};
</script>
